import React, { useEffect, useRef, useState } from "react";

export default function StickyBook({ onBook }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const hero = document.getElementById("hero");
    const footer = document.getElementById("visit");
    if (!hero || !footer) return;

    let heroOut = false;
    let footerIn = false;
    const sync = () => setShow(heroOut && !footerIn);

    const heroObs = new IntersectionObserver(
      ([e]) => { heroOut = !e.isIntersecting; sync(); },
      { threshold: 0.05 }
    );
    const footObs = new IntersectionObserver(
      ([e]) => { footerIn = e.isIntersecting; sync(); },
      { threshold: 0.05 }
    );
    heroObs.observe(hero);
    footObs.observe(footer);
    return () => { heroObs.disconnect(); footObs.disconnect(); };
  }, []);

  return (
    <button
      ref={ref}
      onClick={onBook}
      data-testid="sticky-book-btn"
      data-cursor="hover"
      aria-label="Book a consultation"
      className={`fixed bottom-6 right-6 z-40 rounded-full bg-sage-800 text-cream pl-5 pr-2 py-2 flex items-center gap-3 btn-glow transition-all duration-500 ${
        show ? "opacity-100 translate-y-0 pulse-bounce pointer-events-auto" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      <span className="uppercase text-[11px] tracking-[0.22em]">Book Now</span>
      <span className="grid place-items-center w-10 h-10 rounded-full bg-gold-400 text-sage-900">
        <span className="text-base">✦</span>
      </span>
    </button>
  );
}
